/**
 * @author: Kotaro
 * @description: Сюда инключим все компионенты resources/views/components
 */

const { toggleBlockScroll } = require('./vue/utils/index');


require('../views/components/language-selector/language-selector');
require('../views/components/country-selector/country-selector');
require('../views/components/tooltip/tooltip');
require('@/lara-components/toggle-accordion/toggle-accordion')
require('@/lara-components/global/time/time')

/**
 * TODO Вынес код по header сюда т.к не могу перенести headers.blade в папку, надо проконсультироваться с Ромой и Валерой по этому вопросу
 */


$(document).on('click', '.header__burger', function (event) {
    const target = $(this);
    const value = !target.hasClass('--open')

    toggleBlockScroll(value)
    target.toggleClass('--open');

    $('.header__menu').toggleClass('--open');

    $('.js-show-mobile-header-menu').css('display', value ? 'flex' : 'none');
    $('.js-hide-mobile-header-menu').css('display', value ? 'none' : 'block');
})

// ========================================